import script from "./add-operator.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-operator.vue?vue&type=script&lang=ts&setup=true"

import "./add-operator.vue?vue&type=style&index=0&id=7323323f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7323323f"]])

export default __exports__